<template>
  <div>
    <div class="nk-app-root">
      <div class="nk-main">
        <div class="nk-wrap">
          <Header v-show="!loading_page" />
          <div class="nk-content">
            <div class="container wide-xl">
              <div class="nk-content-inner">
                <Navigation v-show="!loading_page" />
                <div class="nk-content-body" v-show="!loading_page">
                  <div class="nk-content-wrap">
                    <div class="nk-block nk-block-lg">
                      <div class="nk-block-head">
                        <div class="nk-block-head-content d-flex justify-content-between align-items-center">
                          <div>
                            <h4 class="nk-block-title">{{ $t('dm_pl_ai_title') }}</h4>
                            <span class="text-muted small" v-if="preisliste && preisliste.version">{{ $t('dm_preislisten_title') }} — Version {{ preisliste.version }}</span>
                          </div>
                          <div class="d-flex align-items-center" style="gap: 8px;">
                            <button v-if="chatMessages.length > 0" class="btn btn-sm btn-outline-secondary" @click="chatMessages = []">
                              <em class="icon ni ni-trash mr-1"></em> {{ $t('dm_pl_ai_clear') }}
                            </button>
                            <router-link v-if="preisliste && preisliste._id" :to="'/dm/preisliste/' + preisliste._id" class="btn btn-sm btn-outline-secondary">
                              <em class="icon ni ni-list mr-1"></em> {{ $t('dm_preislisten_title') }}
                            </router-link>
                          </div>
                        </div>
                      </div>

                      <div v-if="!preisliste && !loading" class="alert alert-warning">{{ $t('dm_kalk_no_preisliste') }}</div>

                      <div v-if="preisliste" class="dm-chat-page">
                        <!-- Messages -->
                        <div class="dm-chat-messages" ref="chatMessages">
                          <div v-if="chatMessages.length === 0" class="dm-chat-welcome">
                            <div class="dm-chat-welcome-icon">
                              <em class="icon ni ni-spark"></em>
                            </div>
                            <h5>{{ $t('dm_pl_ai_title') }}</h5>
                            <p class="text-muted">{{ $t('dm_pl_ai_hint') }}</p>
                            <div class="dm-chat-suggestions">
                              <button v-for="(s, sIdx) in chatSuggestions" :key="sIdx" class="dm-chat-suggestion" @click="sendMessage(s)">{{ s }}</button>
                            </div>
                          </div>
                          <div v-for="(msg, mIdx) in chatMessages" :key="mIdx" class="dm-chat-msg" :class="'dm-chat-msg-' + msg.role">
                            <div class="dm-chat-avatar" v-if="msg.role === 'assistant'">
                              <em class="icon ni ni-spark"></em>
                            </div>
                            <div v-if="msg.role === 'assistant'">
                              <div class="dm-chat-bubble dm-chat-md" v-html="renderMd(msg.text)"></div>
                              <div v-if="msg.usage" class="dm-chat-usage">
                                {{ msg.usage.total_tokens.toLocaleString('de-DE') }} tokens
                              </div>
                            </div>
                            <div v-else class="dm-chat-bubble">{{ msg.text }}</div>
                          </div>
                          <div v-if="chatLoading" class="dm-chat-msg dm-chat-msg-assistant">
                            <div class="dm-chat-avatar">
                              <em class="icon ni ni-spark"></em>
                            </div>
                            <div class="dm-chat-bubble dm-chat-typing">
                              <span></span><span></span><span></span>
                            </div>
                          </div>
                        </div>

                        <!-- Input -->
                        <div class="dm-chat-input-bar">
                          <div class="dm-chat-input-inner">
                            <input type="text" class="dm-chat-input" v-model="chatInput" :placeholder="$t('dm_pl_ai_input_placeholder')" @keyup.enter="sendMessage(chatInput)" :disabled="chatLoading" />
                            <button class="dm-chat-send" :disabled="!chatInput.trim() || chatLoading" @click="sendMessage(chatInput)">
                              <em class="icon ni ni-send"></em>
                            </button>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../../components/Header.vue";
import Navigation from "../../../components/Navigation.vue";
import Footer from "../../../components/Footer.vue";
import dmPermissionsMixin from "@/mixins/dm-permissions-mixin";
import { getPreislisteList, getPreisliste, preislisteAiChat } from "@/services/dm.service";

export default {
  name: "DmPreislisteChat",
  components: { Header, Navigation, Footer },
  mixins: [dmPermissionsMixin],
  data() {
    return {
      preisliste: null,
      loading: false,
      chatInput: "",
      chatLoading: false,
      chatMessages: [],
      chatSuggestions: [
        "Was kostet eine IBN für eine Vestas V150, 166m?",
        "Vergleiche WKP-basic vs. WKP-Plus für Enercon E-138, 160m",
        "Welche Zusatzprodukte gibt es und was kosten sie?",
        "Welche Anlagen sind in der Preisliste verfügbar?",
      ],
    };
  },
  computed: {
    loading_page() {
      return this.$store.state.loading_page && this.$store.state.loading_page === "setup";
    },
  },
  created() {
    this.loadPreisliste();
  },
  methods: {
    loadPreisliste: function() {
      var self = this;
      self.loading = true;
      // If route has id param, load that; otherwise load the active one
      var id = self.$route.params.id;
      if (id) {
        self.loadById(id);
      } else {
        getPreislisteList()
          .then(function(d) {
            var list = (d.data && d.data.list) || [];
            if (list.length > 0) {
              self.loadById(list[0]._id);
            } else {
              self.loading = false;
            }
          })
          .catch(function(e) {
            self.loading = false;
            self.$store.dispatch("api_error", e);
          });
      }
    },
    loadById: function(id) {
      var self = this;
      getPreisliste(id)
        .then(function(d) {
          self.loading = false;
          if (d && d.data && d.data.preisliste) {
            self.preisliste = d.data.preisliste;
          }
        })
        .catch(function(e) {
          self.loading = false;
          self.$store.dispatch("api_error", e);
        });
    },
    sendMessage: function(text) {
      if (!text || !text.trim() || this.chatLoading) return;
      var msg = text.trim();
      this.chatInput = "";
      // Build history BEFORE adding current message to avoid sending it twice
      var history = this.chatMessages.slice(-10).map(function(m) {
        return { role: m.role, content: m.text };
      });

      this.chatMessages.push({ role: "user", text: msg });
      this.chatLoading = true;
      this.scrollChat();

      var self = this;
      preislisteAiChat(this.preisliste._id, msg, history)
        .then(function(d) {
          self.chatLoading = false;
          var answer = (d && d.data && d.data.answer) || (d && d.message) || "Keine Antwort erhalten.";
          var usage = (d && d.data && d.data.usage) || null;
          self.chatMessages.push({ role: "assistant", text: answer, usage: usage });
          self.scrollChat();
        })
        .catch(function() {
          self.chatLoading = false;
          self.chatMessages.push({ role: "assistant", text: "Fehler bei der Verarbeitung. Bitte versuchen Sie es erneut." });
          self.scrollChat();
        });
    },
    scrollChat: function() {
      var self = this;
      this.$nextTick(function() {
        var el = self.$refs.chatMessages;
        if (el) el.scrollTop = el.scrollHeight;
      });
    },
    renderMd: function(text) {
      if (!text) return "";
      var s = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

      // Tables
      var lines = s.split("\n");
      var out = [];
      var inTable = false;
      var headerDone = false;
      for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim();
        var isTableRow = line.indexOf("|") === 0 && line.lastIndexOf("|") === line.length - 1 && line.length > 2;
        var isSeparator = isTableRow && /^\|[\s\-:|]+\|$/.test(line);
        if (isTableRow) {
          if (!inTable) { out.push('<table class="dm-md-table">'); inTable = true; headerDone = false; }
          if (isSeparator) { headerDone = true; continue; }
          var cells = line.split("|").filter(function(c, idx, arr) { return idx > 0 && idx < arr.length - 1; });
          var tag = !headerDone ? "th" : "td";
          out.push("<tr>" + cells.map(function(c) { return "<" + tag + ">" + c.trim() + "</" + tag + ">"; }).join("") + "</tr>");
          if (!headerDone) headerDone = true;
        } else {
          if (inTable) { out.push("</table>"); inTable = false; }
          out.push(line);
        }
      }
      if (inTable) out.push("</table>");
      s = out.join("\n");

      s = s.replace(/^### (.+)$/gm, '<div class="dm-md-h3">$1</div>');
      s = s.replace(/^## (.+)$/gm, '<div class="dm-md-h2">$1</div>');
      s = s.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
      s = s.replace(/^- (.+)$/gm, '<div class="dm-md-li">$1</div>');
      s = s.replace(/\n\n+/g, '<div class="dm-md-gap"></div>');
      s = s.replace(/\n/g, "<br>");
      return s;
    },
  },
};
</script>

<style scoped>
.dm-chat-page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 220px);
  min-height: 400px;
}

.dm-chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 24px 0;
}

.dm-chat-welcome {
  text-align: center;
  padding: 60px 20px 40px;
}

.dm-chat-welcome-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(232, 117, 26, 0.1);
  color: #E8751A;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 16px;
}

.dm-chat-welcome h5 {
  margin-bottom: 8px;
}

.dm-chat-suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-top: 20px;
}

.dm-chat-suggestion {
  background: rgba(232, 117, 26, 0.06);
  border: 1px solid rgba(232, 117, 26, 0.2);
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 13px;
  color: #c5600e;
  cursor: pointer;
  transition: all 0.15s ease;
}

.dm-chat-suggestion:hover {
  background: rgba(232, 117, 26, 0.14);
}

/* Messages */
.dm-chat-msg {
  margin-bottom: 16px;
  display: flex;
  gap: 12px;
  max-width: 800px;
}

.dm-chat-msg-user {
  margin-left: auto;
  justify-content: flex-end;
}

.dm-chat-msg-assistant {
  justify-content: flex-start;
}

.dm-chat-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(232, 117, 26, 0.1);
  color: #E8751A;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
  margin-top: 2px;
}

.dm-chat-bubble {
  padding: 12px 16px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.6;
  word-break: break-word;
}

.dm-chat-msg-user .dm-chat-bubble {
  background: #E8751A;
  color: #fff;
  border-bottom-right-radius: 4px;
  max-width: 600px;
}

.dm-chat-msg-assistant .dm-chat-bubble {
  background: rgba(128, 128, 128, 0.06);
  color: #333;
  border-bottom-left-radius: 4px;
  max-width: 700px;
}

.dm-chat-usage {
  font-size: 11px;
  color: #aaa;
  margin-top: 4px;
  padding-left: 4px;
}

.dm-chat-md {
  white-space: normal;
}

/* Markdown styles */
.dm-md-h2 {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #222;
}

.dm-md-h3 {
  font-size: 14px;
  font-weight: 600;
  margin-top: 12px;
  margin-bottom: 6px;
  color: #444;
}

.dm-md-li {
  padding-left: 14px;
  position: relative;
  margin: 3px 0;
}

.dm-md-li::before {
  content: "·";
  position: absolute;
  left: 0;
  font-weight: 700;
  color: #E8751A;
}

.dm-md-gap {
  height: 10px;
}

.dm-md-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin: 8px 0;
}

.dm-md-table th {
  background: rgba(128, 128, 128, 0.1);
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.dm-md-table th,
.dm-md-table td {
  padding: 6px 10px;
  border: 1px solid rgba(128, 128, 128, 0.15);
  text-align: left;
}

.dm-md-table tr:nth-child(even) {
  background: rgba(128, 128, 128, 0.04);
}

/* Typing */
.dm-chat-typing {
  display: flex;
  gap: 5px;
  padding: 14px 18px;
}

.dm-chat-typing span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #aaa;
  animation: dm-typing 1.2s infinite;
}

.dm-chat-typing span:nth-child(2) { animation-delay: 0.2s; }
.dm-chat-typing span:nth-child(3) { animation-delay: 0.4s; }

@keyframes dm-typing {
  0%, 60%, 100% { opacity: 0.3; transform: translateY(0); }
  30% { opacity: 1; transform: translateY(-4px); }
}

/* Input bar */
.dm-chat-input-bar {
  padding: 16px 0;
  border-top: 1px solid rgba(128, 128, 128, 0.12);
}

.dm-chat-input-inner {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 800px;
}

.dm-chat-input {
  flex: 1;
  border: 1px solid rgba(128, 128, 128, 0.2);
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

.dm-chat-input:focus {
  border-color: #E8751A;
  box-shadow: 0 0 0 3px rgba(232, 117, 26, 0.08);
}

.dm-chat-send {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #E8751A;
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 16px;
  transition: background 0.15s;
}

.dm-chat-send:hover:not(:disabled) {
  background: #d0680f;
}

.dm-chat-send:disabled {
  opacity: 0.4;
}
</style>
